import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "./UseAuthStore";
import { useEffect } from "react";
import { getUser } from "./Services";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { USER_ROLES } from "@/utils/constants";
import { saveUser } from "@/slices/userSlice";
import { isEmpty } from "lodash";

interface AdminAuthRequiredProps {
  children?: React.ReactNode;
}

export const AdminAuthRequired = ({ children }: AdminAuthRequiredProps) => {
  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.user.user);
  const token = useAuthStore((state) => state.accessToken);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await getUser();

        dispatch(saveUser({ ...res.data }));
      } catch (error) {}
    };

    if (token) {
      fetchUser();
    }
  }, []);

  const location = useLocation();

  if (!token) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  } else if (!isEmpty(user) && !!token && user.role !== USER_ROLES.USER) {
    return children ? <>{children}</> : <Outlet />;
  } else if (!isEmpty(user) && token && user.role !== USER_ROLES.ADMIN) {
    return (
      <Navigate to="/dashboard/notes" replace state={{ from: location }} />
    );
  }

  return children ? <>{children}</> : <Outlet />;
};
